<template>
  <main class="main">
      <transition name="slide">
        <Cover v-if="status === 0"
          @click-female-btn="selectGender($event)"
          @click-male-btn="selectGender($event)"
        ></Cover>
      </transition>

      <transition>
        <Question
          v-if="status === 1 && currentQuestion"
          :question-num="currentQuestion.num"
          :question-text="currentQuestion.text"
          :point-yes="currentQuestion.point_yes"
          :point-no="currentQuestion.point_no"
          @click-yes-btn="doAnswer($event)"
          @click-no-btn="doAnswer($event)"
          @click-restart="doRestart"
        ></Question>
      </transition>

      <transition name="up">
      <Result
        v-if="!currentQuestion"
        :property-all="propertyAll"
        :your-type="yourType"
        :recom-course="recomCourse"
        @click-restart="doRestart"
      ></Result>
      </transition>
  </main>
</template>


<script>
/* eslint no-unused-vars: 0 */
import Cover from './Cover'
import Question from './Question'
import Result from './Result'

let gender
let resultTypeNo

let maxType1, maxType2
let resultType1, resultType2
let quadrant

let fixedType

export default {
  name: 'Container',

  components: {
    Cover: Cover,
    Question: Question,
    Result: Result
  },

  // 親コンポーネントのスクリプト
  data: () => {
    return {
      status: 0, // 0:cover, 1:Question, 2:Result

      // 問題文
      questions: require('../assets/data/questions.json'),

      // 現在表示している問題文のインデックス
      currentNum: 0,

      // 自分の回答を格納する配列
      yourAnswers: [],

      // type.jsonをfetchしてtypeとして格納
      type: require('../assets/data/type.json'),

      // 自分のtypeNoのテキストを格納する配列
      yourType: [],

      propertyAll: {}
    }
  },

  computed: {
    // 現在表示している問題文
    currentQuestion: function () {
      // console.log('== this.currentNum ==')
      // console.log(this.currentNum)

      // console.log('== this.questions[this.currentNum] ==')
      // console.log(this.questions[this.currentNum])

      return this.questions[this.currentNum]

      // currentNum ５は、質問文が undefinedになる。そのため falseとなり結果画面が表示される
      // 問題文がないと false になる
    },

    // 診断結果によるおすすめ講座を返す
    recomCourse: function () {

      // console.log('== this.yourAnswers ==')
      // console.log(this.yourAnswers)
      // console.log(this.yourAnswers.length)

      const yourAnswers = this.yourAnswers

      const property0 = [yourAnswers[0], yourAnswers[1], yourAnswers[2]]
      const property1 = [yourAnswers[3], yourAnswers[4], yourAnswers[5]]
      const property2 = [yourAnswers[6], yourAnswers[7], yourAnswers[8]]
      const property3 = [yourAnswers[9], yourAnswers[10], yourAnswers[11]]
      const property4 = [yourAnswers[12], yourAnswers[13], yourAnswers[14]]
      const property5 = [yourAnswers[15], yourAnswers[16], yourAnswers[17]]

      // console.log('property0 = ' + property0)
      // console.log('property1 = ' + property1)
      // console.log('property2 = ' + property2)
      // console.log('property3 = ' + property3)
      // console.log('property4 = ' + property4)
      // console.log('property5 = ' + property5)

      // 各配列の合計を出す。それを連想配列に格納
      let propertyAll = this.propertyAll
      propertyAll.extra = property0.reduce((sum, element) => sum + element, 0)
      propertyAll.self = property1.reduce((sum, element) => sum + element, 0)
      propertyAll.creative = property2.reduce((sum, element) => sum + element, 0)
      propertyAll.harmony = property3.reduce((sum, element) => sum + element, 0)
      propertyAll.devote = property4.reduce((sum, element) => sum + element, 0)
      propertyAll.logic = property5.reduce((sum, element) => sum + element, 0)

      // console.log(propertyAll) // {extra: 60, self: 22, create: 4 ・・・}

      const propertyAllTemp = JSON.parse(JSON.stringify(propertyAll))

      const extraScore = propertyAllTemp.extra
      const selfScore = propertyAllTemp.self
      const creativeScore = propertyAllTemp.creative

      let cnt = 1
      while (Object.keys(propertyAllTemp).length > 0) {
        // console.log(cnt)

        // 配列内で最大のkeyを格納する変数
        let maxKey = ''

        // 配列内で最大の値を調べる
        for (let key in propertyAllTemp) {
          if (maxKey === '' || propertyAllTemp[key] > propertyAllTemp[maxKey]) {
            maxKey = key
          }
        }

        // 配列内で最大の値を出力
        // console.log(maxKey, propertyAllTemp[maxKey])
        if (cnt == 1) {
          maxType1 = maxKey
        }
        if (cnt == 2) {
          maxType2 = maxKey
        }

        // 出力したkeyは配列から削除していく
        delete propertyAllTemp[maxKey]

        cnt++
      }

      // console.log('== maxTypes ==')
      // console.log(maxType1)
      // console.log(maxType2)

      const type = this.type

      this.getResultType()

      if(resultType2.length == 0) {
        // console.log('maxType1とmaxType2を入れ替えてもう一回')
        // 同じ変数に入れてはいけない
        const work = maxType2
        maxType2 = maxType1
        maxType1 = work
        this.getResultType();
      }

      // console.log('==resultType1==')
      // console.log(resultType1)
      // console.log('==resultType2==')
      // console.log(resultType2)

      resultTypeNo = `0${resultType2[0].typeNo}`.slice(-2) // オブジェクトはこの方法で取得
      // console.log(resultTypeNo) // 01-15のType確定
      // console.log(gender)

      // method実行
      this.getTypeText()

      // console.log('== score ==')
      // console.log(extraScore)
      // console.log(selfScore)
      // console.log(creativeScore)

      if (extraScore >= selfScore) {
        // 外向性の方がスコアが高い(もしくは同じ) 第一象限 or 第四象限
        if (creativeScore > 32) {
          quadrant = 1
        } else {
          quadrant = 4
        }
      } else {
        // 自律性の方がスコアが高い 第二象限 or 第三象限'
        if (creativeScore > 32) {
          quadrant = 2
        } else {
          quadrant = 3
        }
      }

      // console.log('== recomCourse ==')
      // console.log(`${resultTypeNo}${gender}${quadrant}`)

      fixedType = `${resultTypeNo}${gender}${quadrant}`
      return fixedType
    },
  },

  watch: {
    status: function(next, prev) {
      // console.log('next:' + next)
      if(next==1){
        window.output_analysis('【心理診断】：診断中')
      }else if(next==2){
        window.output_analysis(`【心理診断】：結果ページ_${fixedType}`)
      }
    },

    currentNum: function(next, prev) {
      document.querySelector('.qu-head__num span').style.opacity = 0
      document.querySelector('.qu-select__text span').style.opacity = 0
      setTimeout(() => {
        document.querySelector('.qu-head__num span').style.opacity = 1
        document.querySelector('.qu-select__text span').style.opacity = 1
      }, 300)
    }
  },

  methods: {
    selectGender: function (val) {
      gender = val
      this.status = 1
    },

    doAnswer: function (score) {
      this.yourAnswers[this.currentNum] = score
      // console.log('スコア＝' + this.yourAnswers[this.currentNum])
      this.nextQuestion()
    },

    // 次の問題へ進む
    nextQuestion: function () {
      if (this.currentNum < this.questions.length) {
        this.currentNum += 1
      }

      // console.log('nextQuestion後')
      // console.log(this.currentNum)
    },

    // type別のテキストを取得 yourTypeに格納
    getTypeText: function () {
      this.status = 2
      const type = this.type
      // console.log('== type ==')
      // console.log(type)
      // console.log('== resultTypeNo ==')
      // console.log(resultTypeNo)

      let yourType = []

      for (let elem in type) {
        if(type[elem]['typeNo'] == resultTypeNo) {
          yourType[0] = type[elem]['type_text']
          yourType[1] = type[elem]['type_name']
          yourType[2] = type[elem]['description']
          yourType[3] = type[elem]['advice']
          break
        }
      }
      // console.log('== yourType ==')
      // console.log(yourType)
      this.yourType = yourType
    },

    getResultType: function() {
      const type = this.type
      resultType1 = type.filter((property) => {
        return (property.property_1st === maxType1)
      })
      resultType2 = resultType1.filter((property) => {
        return (property.property_2nd === maxType2)
      })
    },

    // 最初から問題をやり直す
    doRestart: function () {
      this.currentNum = 0
      this.status = 0

      // 回答データを完全にリセット
      this.yourAnswers = []

      // 診断結果データをリセット
      this.yourType = []
      this.propertyAll = {}

      // グローバル変数もリセット
      gender = undefined
      resultTypeNo = undefined
      maxType1 = undefined
      maxType2 = undefined
      resultType1 = undefined
      resultType2 = undefined
      quadrant = undefined
      fixedType = undefined

      // console.log('Restartボタン後')
      // console.log(this.currentNum)
    }
  }
}


function fadeIn(node, duration) {
  // display: noneでないときは何もしない
  if (getComputedStyle(node).display !== 'none') return

  // style属性にdisplay: noneが設定されていたとき
  if (node.style.display === 'none') {
    node.style.display = ''
  } else {
    node.style.display = 'block'
  }
  node.style.opacity = 0

  let start = performance.now()

  requestAnimationFrame(function tick(timestamp) {
    // イージング計算式（linear）
    var easing = (timestamp - start) / duration;

    // opacityが1を超えないようにする
    node.style.opacity = Math.min(easing, 1)

    // opacityが1より小さいとき
    if (easing < 1) {
      requestAnimationFrame(tick)
    } else {
      node.style.opacity = ''
    }
  });
}
</script>


<style scoped>
.slide-leave-active {
  transition: all .6s ease;
  position: absolute;
  z-index: 10;
}
.slide-leave-to {
  transform: translateX(-100%);
}

.up-enter {
  position: absolute;
  transform: translateY(100%);
}
.up-enter-active {
  transition: all .6s ease;
}
.up-enter-to {
  transform: translateY(0);
}
</style>